/* src/app/components/review/folders/folders.component.scss */
.node-selected {
  background-color: #fde395;
}
.mat-tree {
  border: 1px solid #c1bfbf;
}
:host-context(.dark-theme) .mat-tree {
  border: 1px solid rgba(255, 255, 255, 0.2);
}
mat-tree-node .add-icon {
  display: none;
  cursor: pointer;
}
mat-tree-node:hover .add-icon {
  display: block;
}
.refresh-icon,
.rename-icon {
  color: #3f51b5;
}
.delete-icon {
  color: red;
}
.delete-icon,
.rename-icon {
  opacity: 0;
  cursor: default;
}
.has-node-selected .delete-icon,
.has-node-selected .rename-icon {
  opacity: 1;
  cursor: pointer;
}
:host ::ng-deep .mat-mdc-progress-spinner circle,
.mat-mdc-progress-spinner circle {
  stroke: #3f51b5;
}
.fa-regular {
  color: #3f51b5;
}
.fa-folder-closed {
  color: #656565;
}
:host-context(.dark-theme) .delete-icon {
  color: #ff5b4f;
}
:host-context(.dark-theme) .refresh-icon,
:host-context(.dark-theme) .rename-icon {
  color: #88a3ff;
}
:host-context(.dark-theme) .fa-regular {
  color: #88a3ff;
}
:host-context(.dark-theme) .fa-folder-closed {
  color: #a0a0a0;
}
mat-tree-node button span {
  display: flex;
  justify-content: center;
}
/*# sourceMappingURL=folders.component.css.map */
